import { ApiUtil as api } from "@/utils/api.util.js";

export class LogService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/logs/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/log.service.js